import React, { useEffect, useState } from 'react';
import { InstantSearch } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import LoadingArea from '@molecules/LoadingArea';
import { getAlgoliaIndexNameGlobal } from '@general/helpers/search.helpers';
import useAlgoliaClient from '@hooks/search/useAlgoliaClient';

const SearchContainer = ({ index, refresh = false, searchState, children, onSearchStateChange }) => {
    const { searchClient } = useAlgoliaClient();
    const indexName = getAlgoliaIndexNameGlobal(index);

    if (!searchClient) {
        return <LoadingArea />;
    }

    const attrs = {};

    if (searchState) {
        attrs.searchState = searchState;
    }

    if (onSearchStateChange) {
        attrs.onSearchStateChange = onSearchStateChange;
    }

    return (
        <InstantSearch indexName={indexName} refresh={refresh} searchClient={searchClient} {...attrs}>
            {children}
        </InstantSearch>
    );
};

SearchContainer.propTypes = {
    index: PropTypes.string.isRequired,
    refresh: PropTypes.bool,
    searchState: PropTypes.object,
    children: PropTypes.node.isRequired,
    onSearchStateChange: PropTypes.func,
};

export default SearchContainer;
